<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <HelpFiledStep2
      text="2. Полное наименование проекта"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_NAME']"
    />
    <uf_name></uf_name>

    <HelpFiledStep2
      text="3. Программа финансовой поддержки"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_SUPPORT_PROG_ID']"
    />
    <uf_support_prog_id></uf_support_prog_id>

    <div class="content-title content-mb-14">
      4. Оказывал ли региональный фонд развития промышленности методологическую
      и/или информационную помощь при подготовке заявки в Фонд развития
      промышленности
      <span class="icon-warning"></span>
      <VDropdown
        tag="span"
        trigger="click"
        placement="bottom"
        popperClass="custom-popper"
        style="display: inline"
      >
        <a class="icon-help icon-help-l40" />
        <template #popper>
          <div class="custom-popper-content">
            {{ h4tooltip }}
          </div>
        </template>
      </VDropdown>
    </div>
    <uf_is_reg_fond_help></uf_is_reg_fond_help>

    <div class="content-title content-mb-14">
      <span>5</span>. В структуре владения уставным капиталом преобладающее
      участие имеет паевой инвестиционный фонд
    </div>
    <uf_is_prevails_mutual_invest_fund></uf_is_prevails_mutual_invest_fund>

    <div class="content-title content-mb-14">
      6. Требуемый объем финансирования со стороны Фонда, тыс. руб.
    </div>
    <uf_sum_request></uf_sum_request>

    <div class="content-title content-mb-14">7. Сроки займа, мес.</div>
    <uf_month_return></uf_month_return>

    <div class="content-title content-mb-14">8. Отрасль промышленности</div>
    <uf_industry_id></uf_industry_id>

    <div class="content-title content-mb-14">9. Подотрасль промышленности</div>
    <uf_sub_industry_id></uf_sub_industry_id>

    <template v-if="$parent.project.UF_SETTING && $parent.project.UF_SETTING.IS_VIEW_NEW_INFORMATION_PROJECT">
      <div class="content-title content-mb-14">
        10. Информация о продукции проекта
        <VDropdown
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          style="display: inline"
        >
          <a class="icon-help icon-help-l40" />
          <template #popper>
            <div class="custom-popper-content">
              Продукты проекта, перечисленные в резюме должны быть синхронизированы с перечнем из финансовой модели
            </div>
          </template>
        </VDropdown>
      </div>
      <ProjectOkpdProducts></ProjectOkpdProducts>
    </template>
    <template v-else>
      <div class="content-title content-mb-14">
        10. Информация о продукции (в соответствии с перечнем ОКПД)
      </div>
      <okpd></okpd>
    </template>

    <template v-if="isViewComplectyushieProduct">
      <div class="content-title content-mb-14">
        11. Комплектующее изделие (в соотв. с ПП РФ от 17.07.2015 №719)
      </div>
      <!--<select
        v-model="project.UF_VID_TYPE_PRODUCT_LIST_ID"
        class="sel-dropdown i-main-style i-wid-50 mrg-bad10"
        v-on:change="onChangeTypeProductList()"
        :disabled="$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in directory.sp_vid_type_product_list_id"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_VID_TYPE_PRODUCT_LIST_ID"
          )
        }}
      </div>
      <template v-if="isShowVidType">-->
      <br />
      <PromProducts></PromProducts>
      <!-- </template> -->
    </template>

    <div class="content-title content-mb-14">
      <span v-if="isViewComplectyushieProduct">12</span><span v-else>11</span>.
      Аннотация проекта
    </div>
    <uf_annotation></uf_annotation>

    <div class="content-title content-mb-14">
      <span v-if="isViewComplectyushieProduct">13</span><span v-else>12</span>.
      Место реализации проекта
    </div>
    <place></place>

    <div class="content-title content-mb-14">
      <span style="float:left;">
        <span v-if="isViewComplectyushieProduct">14</span
        ><span v-else>13</span>. Продукция производится на спецтерритории</span
      >
      <span style="float: left;margin-top: 12px;margin-left: 10px;">
        <label class="switch">
          <input type="checkbox" v-model="project.UF_IS_PRODACTION_SP_TERR" />
          <span class="slider round"></span>
        </label>
      </span>
    </div>
    <SpecialPlace v-if="project.UF_IS_PRODACTION_SP_TERR"></SpecialPlace>

    <template v-if="project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1">
      <uf_okpo>
        <span v-if="isViewComplectyushieProduct">15</span
        ><span v-else>14</span>.
      </uf_okpo>
    </template>
    <template v-if="project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">
      <div class="content-title content-mb-14">
        <span v-if="isViewComplectyushieProduct">{{ 15 + okpoShift }}</span
        ><span v-else>{{ 14 + okpoShift }}</span>. Финансовые показатели организации
      </div>
      <financialIndicator></financialIndicator>
      <dividendsIndicator :isMainPunct="false"></dividendsIndicator>
    </template>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import VueTagsInput from "@johmun/vue-tags-input";
import { AUTH_URL } from "@/common/config";
import Vue from "vue";
import SystemIntegrator from "@/components/project/form/partial/SystemIntegrator";
import Digital_solution from "@/components/project/form/partial/DigitalSolution";
import System_equipment from "@/components/project/form/partial/SystemEquipment";
import Uf_name from "@/components/project/form/partial/uf_name";
import Uf_support_prog_id from "@/components/project/form/partial/uf_support_prog_id";
import Uf_sum_request from "@/components/project/form/partial/uf_sum_request";
import Uf_month_return from "@/components/project/form/partial/uf_month_return";
import Uf_industry_id from "@/components/project/form/partial/uf_industry_id";
import Uf_sub_industry_id from "@/components/project/form/partial/uf_sub_industry_id";
import Uf_is_ndt from "@/components/project/form/partial/uf_is_ndt";
import Okpd from "@/components/project/form/partial/okpd";
import ProjectOkpdProducts from "@/components/project/form/partial/ProjectOkpdProducts";
import Uf_annotation from "@/components/project/form/partial/uf_annotation";
import Uf_available_results from "@/components/project/form/partial/uf_available_results";
import Place from "@/components/project/form/partial/place";
import Subcontractors from "@/components/project/form/partial/subcontractors";
import Import_plan from "@/components/project/form/partial/import_plan";
import Uf_result_natural from "@/components/project/form/partial/uf_result_natural";
import Target_years from "@/components/project/form/partial/target_years";
import Export_countries from "@/components/project/form/partial/export_countries";
import Uf_is_reg_fond_help from "@/components/project/form/partial/uf_is_reg_fond_help";
import PromProducts from "@/components/project/form/partial/PromProducts";
import HighTechList from "@/components/project/form/partial/HighTechList";
import SpecialPlace from "@/components/project/form/partial/SpecialPlace";
import financialIndicator from "@/components/project/form/partial/FinancialIndicator";
import { Dropdown as VDropdown } from "floating-vue";
import HelpFiledStep2 from "@/components/project/form/subpartial/HelpFiledStep2.vue";
import Uf_okpo from "@/components/project/form/partial/uf_okpo";
import uf_is_prevails_mutual_invest_fund from "@/components/project/form/partial/uf_is_prevails_mutual_invest_fund";
import dividendsIndicator from "@/components/project/form/partial/DividendsIndicator.vue";

export default {
  name: "step2",
  props: ["step", "project"],
  components: {
    Uf_okpo,
    dividendsIndicator,
    SpecialPlace,
    HighTechList,
    PromProducts,
    Uf_is_reg_fond_help,
    Export_countries,
    Target_years,
    Uf_result_natural,
    Import_plan,
    Subcontractors,
    Place,
    Uf_available_results,
    Uf_annotation,
    Okpd,
    ProjectOkpdProducts,
    Uf_sub_industry_id,
    Uf_industry_id,
    Uf_month_return,
    Uf_sum_request,
    Uf_support_prog_id,
    Uf_name,
    Uf_is_ndt,
    System_equipment,
    Digital_solution,
    SystemIntegrator,
    financialIndicator,
    VueTagsInput,
    uf_is_prevails_mutual_invest_fund,
    VDropdown,
    HelpFiledStep2
  },
  data() {
    return {
      selectedTags: [],
      h4tooltip:
        "Успешная реализация Вашего проекта важна для региона. Если Вы хотите предоставить Региональному фонду доступ к текущей заявке, получить консультационную поддержку и помощь, выберите «Да» в выпадающем списке:",
      h14tooltipShow: false,
      h14tooltip:
        "<img src='https://lkbe.frprf.ru/images/project/p13_info.png' />",
      siteUrl: "",
      tag: "",
      tags: [],
      RESULT_INTELLECTUAL_ACTIVITY: false,
      isShowVidType: false,
      h18tooltip:
        'Ставка по предоставляемому целевому займу может быть изменена Фондом на 1% годовых,  если  выполнено требование п.7.3 Стандарта "Цифровизация промышленности"',
      h15tooltip:
        "Для возможного применения ставки 1 (один) процент годовых к займам, финансируемым по\n" +
        "                                программе «Цифровизация промышленности», Системный интегратор цифровых и\n" +
        "                                технологических\n" +
        "                                решений (далее - Системный интегратор), привлеченный в качестве Ключевого\n" +
        "                                исполнителя\n" +
        "                                (Одобренный ФРП при принятии решения о предоставлении займа) по проекту, должен\n" +
        "                                соответствовать следующим критериям:<br/>\n" +
        "                                1. являться резидентом РФ (определяется в соответствии с законодательством о валютном регулировании и валютном контроле);<br/>\n" +
        "                                2. не являться дочерним хозяйственным обществом (определяется в соответствии с ч. 1 ст. 67.3 ГК РФ) юридических лиц, созданных в соответствии с законодательством иностранных государств;<br/>\n" +
        "                                3. не находиться  процессе ликвидации или банкротства;<br/>\n" +
        "                                4. выплаты Заемщика по договорам/контрактам, заключенным с Системным интегратором в ходе реализации проекта составляют более 50% от суммы займа;<br/>\n" +
        "                                5. должен быть включен в один из рейтингов (применению подлежит актуальный рейтинг на последнюю отчетную дату и учитывается включение ключевого исполнителя в последнюю версию рейтинга российских ИТ-компаний), публикующихся на следующих информационных ресурсах:<br/>\n" +
        '                                • Раздел "ИТ-консалтинг (разработка и системная интеграция)" рэнкинга "Список крупнейших российских консалтинговых групп и компаний" Эксперт-РА (https://raex-a.ru/);<br/>\n' +
        "                                • Крупнейшие ИТ-компании России Cnews (www.cnews.ru);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Tadviser (www.tadviser.ru).",
      isViewComplectyushieProduct: false
    };
  },
  created() {
    this.siteUrl = AUTH_URL;
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "tree/industry",
      "code_okpd",
      "regions",
      "sp_monogorod",
      "list_import_plan",
      "product_plan_import",
      "start_pokazatel",
      "tree/vid_prom_products",
      "sp_vid_type_product_list_id",
      "high_tehnology_sp",
      "sp_ndt"
    ]);

    if (this.project.SUBCONTRACTORS.length === 0) {
      //this.project.SUBCONTRACTORS.push({});
    }

    if (this.project.INDICATORS.items.length === 0) {
      this.project.INDICATORS.items = new Object();
    }
    let m = this;
    this.project.INDICATORS.INDICATORS_ID.forEach(function(indicator) {
      if (typeof m.project.INDICATORS.items[indicator] === "undefined") {
        Vue.set(m.project.INDICATORS.items, indicator, []);
      }
      for (
        let year = m.project.INDICATORS.yearStart;
        year <= m.project.INDICATORS.yearEnd;
        year++
      ) {
        let t = m.project.INDICATORS.items[indicator].filter(
          c => c.UF_INDICATORS_YEAR === year
        );
        if (t.length === 0) {
          m.project.INDICATORS.items[indicator].push({
            UF_INDICATORS_VALUE: 0,
            UF_INDICATORS_YEAR: year,
            UF_INDICATORS_ID: indicator
          });
        }
      }
    });

    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"])
      .then(() => {}, this);

    this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_vid_type_product_list_id"])
      .then(() => {
        this.isShowViewVidProduct();
      }, this);

    this.isViewComplectyushieProduct =
      this.$parent.project.UF_SETTING.IS_VIEW_VID_TYPE_PRODUCT_LIST == 1
        ? true
        : false;
  },
  methods: {
    getInfoproductionId(code) {
      let t = this.directory.tree_sp_infoproduction.filter(
        c => c.CODE === code
      );
      if (t.length > 0 && t[0].URL !== null) {
        return t[0].ID;
      }
      return "";
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID === id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    },
    onChangeTypeProductList() {
      this.isShowViewVidProduct();
      this.$parent.removeError(
        "PROJECTS",
        "LOGIC",
        "UF_VID_TYPE_PRODUCT_LIST_ID"
      );
    },
    isShowViewVidProduct() {
      this.isShowVidType = false;
      this.directory.sp_vid_type_product_list_id.filter(function(el) {
        if (
          el.IS_VIEW_SP_VID_PRODUCTION === 1 &&
          el.ID == this.project.UF_VID_TYPE_PRODUCT_LIST_ID
        ) {
          this.isShowVidType = true;
        }
      }, this);

      return this.isShowVidType;
    }
  },
  computed: {
    okpoShift() {
      return this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1
        ? 1
        : 0;
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
